import { FC, PropsWithChildren, ReactNode, useContext } from "react";
import { AutoLogout, HeaderActionBar, Footer } from "@/components";
import { AuthenticationContext } from "@/context";

import styles from "./PageLayout.module.scss";
import { FeedbackButton } from "@/components/Feedback";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";

interface PageLayoutProps {
  children: ReactNode;
}

export const PageLayout: FC<PropsWithChildren<PageLayoutProps>> = ({ children }: PropsWithChildren<PageLayoutProps>) => {
  const { isUserLoggedIn } = useContext(AuthenticationContext);

  return (
    <div className={styles.PageContainer}>
      {isUserLoggedIn() && <AutoLogout />}
      <HeaderActionBar />
      <div role="main" className={styles.LayoutBackground}>
        <Stack alignment="center" spacing="small">
          {children}
        </Stack>
        <Shelf spacing="none">
          <Shelf.Spacer />
          <FeedbackButton />
        </Shelf>
      </div>
      <Footer />
    </div>
  );
};
